<div *ngIf="!notConnected || website?.domain_hash">
  <div>
    <db-cdn-notice [websiteId]="websiteId"></db-cdn-notice>
    <db-booster-notices [websiteId]="websiteId"></db-booster-notices>
    <div class="ds-notification-warning ds-notification-error" *ngIf="boosterUpdateAvailable && boosterPluginIsActive">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p>
          <b>Update Required:</b> To ensure that optimization continues to work as expected, please update the Booster plugin to the latest version.
        </p>
      </div>
    </div>
    <div class="db-booster-image_optimizer__general">
      <ng-container *ngIf="imageOptimizerPluginIsActive" [ngTemplateOutlet]="forIO"></ng-container>

      <ng-container *ngIf="!imageOptimizerPluginIsActive" [ngTemplateOutlet]="defaultView"></ng-container>
    </div>
  </div>
</div>

<div class="db-trouble-instructions" *ngIf="notConnected && !website?.domain_hash">
  <div>
    <db-booster-trouble-instructions [insideWebsite]="true" [website]="website"
                                     [currentSubscription]="currentSubscription"></db-booster-trouble-instructions>
  </div>
</div>


<ng-template #forIO>
  <div>
    <db-image-limits-banner class="mb20" [websiteId]="website?.id"
                            [currentSubscription]="currentSubscription" *ngIf="currentSubscription?.trialBoosterClient"></db-image-limits-banner>
    <db-optimization-modes class="mb20" [websiteId]="website?.id"
                           [userSubscription]="currentSubscription"></db-optimization-modes>
    <db-image-optimizer-section [website]="website"  [websiteScore]="website?.score" [boosterPluginIsActive]="boosterPluginIsActive" [currentSubscription]="currentSubscription"></db-image-optimizer-section>
    <db-image-optimizer-webp class="mt20" [website]="website" [websiteId]="website?.id" [currentSubscription]="currentSubscription" [boosterPluginIsActive]="boosterPluginIsActive" [ioPluginIsActive]="imageOptimizerPluginIsActive"></db-image-optimizer-webp>
  </div>
</ng-template>

<ng-template #defaultView>

  <db-optimize-images
    *ngIf="!(currentSubscription?.trialBoosterClient
      || currentSubscription?.bundleClient
      || currentSubscription?.oneProductClient) && !!boosterPluginIsActive"
    [currentSubscription]="currentSubscription"></db-optimize-images>
  <db-image-optimizer
    *ngIf="!(currentSubscription?.trialBoosterClient
      || currentSubscription?.bundleClient
      || currentSubscription?.oneProductClient) && !boosterPluginIsActive" [fromBooster]="true">
  </db-image-optimizer>
  <db-optimize-images-free
    *ngIf="currentSubscription?.trialBoosterClient
      || currentSubscription?.bundleClient
      || currentSubscription?.oneProductClient"
    [currentSubscription]="currentSubscription"></db-optimize-images-free>
  <div
    *ngIf="currentSubscription?.trialBoosterClient"
    class="db-floating-box-wrap">
    <db-subscription-block
      [userSubscription]="currentSubscription"
      [websiteId]="websiteId"></db-subscription-block>
    <db-optimize-with-booster-pro
      [imageStats]="stats"
      [pageCount]="pageCount"
      [websiteId]="websiteId"></db-optimize-with-booster-pro>
  </div>
</ng-template>
